<template>
  <div class="loading_container" v-if="loading">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only"></span>
    </div>
  </div>

  <div class="main" v-else>
    <!-- Side Navbar -->
    <SideBar />
    <!-- Body-Content -->
    <div class="body-content">
      <!-- Top Navbar -->
      <TopBar />
      <!-- Body -->
      <div class="container-fluid body-container plan-page">
        <!-- Stripe -->
        <div v-if="profile.subscription_id">
          <div class="row gy-4">
            <div class="col-lg-6">
              <div class="tab">
                <h1>Plano Free</h1>
                <a class="btn btn-small" style="visibility: hidden">.</a>
              </div>
              <div class="description-part section plan">
                <div style="padding-top: 0.2rem">
                  <strong class="price">Gratuito</strong>
                  <em class="current-plan" v-if="profile.plan === 'Free'">
                    (seu plano)</em
                  >
                  <em class="current-plan" v-else style="visibility: hidden">.</em>
                  <ul class="mt-4">
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Curso de
                      Introdução à AV
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Comunidade
                      Virtap
                    </li>
                    <li>
                      <i class="fas fa-times-circle" style="color: #f64b2f"></i>Vídeo
                      aulas exclusivas
                    </li>
                    <li>
                      <i class="fas fa-times-circle" style="color: #f64b2f"></i>Propostas
                      ilimitadas
                    </li>
                    <li>
                      <i class="fas fa-times-circle" style="color: #f64b2f"></i>Prioridade
                      nas propostas
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="tab" style="background: #7fcfd333; border-bottom: 0">
                <h1>Plano Starter</h1>
                <a
                  class="btn btn-small"
                  @click="manageStripeSubscription()"
                  v-if="profile.subscription_id && profile.plan === 'Starter'"
                  ><i class="fa fa-gear" style="padding-right: 5px"></i> Gerenciar</a
                >
                <a
                  class="btn btn-small"
                  @click="subscribe('Starter')"
                  v-else-if="profile.plan === 'Free'"
                  ><i class="fa fa-cart-shopping" style="padding-right: 5px"></i>
                  Assinar</a
                >
                <a class="btn btn-small" style="visibility: hidden" v-else>.</a>
              </div>

              <div class="description-part section plan" style="background: #7fcfd333">
                <div style="padding-top: 0.2rem">
                  <strong class="price">R$ 49,90/mês</strong>
                  <em class="current-plan" v-if="profile.plan === 'Starter'">
                    (seu plano)</em
                  >
                  <em class="current-plan" v-else style="visibility: hidden">.</em>
                  <ul class="mt-4">
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Curso de
                      Introdução à AV
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Comunidade
                      Virtap
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Vídeo
                      aulas exclusivas
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Propostas
                      ilimitadas
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Prioridade
                      nas propostas
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Virtap -->
        <div v-else>
          <div class="alert alert-warning mb-4 under-review" v-if="profile.status == 1">
            <i class="fa-solid fa-circle-exclamation"></i> Seu perfil está sendo analisado
            pela nossa equipe.<br />
            Assim que for aprovado, você poderá assinar o Virtap Club e aproveitar todos
            os benefícios!
          </div>

          <div v-else>
            <div
              class="alert alert-warning mb-4 text-center"
              v-if="
                profile.latest_subscription && profile.latest_subscription.status === 1
              "
            >
              Você possui uma fatura em aberto para o plano
              <strong>{{ formatPlan(profile.latest_subscription.plan) }}</strong
              >.

              <div class="admin-buttons-h mt-3">
                <a class="btn" @click="subscribe(profile.latest_subscription.plan)"
                  ><i class="fa fa-cart-shopping" style="padding-right: 5px"></i> Pagar
                  fatura e ativar plano</a
                >
              </div>
            </div>
            <div
              class="alert alert-danger mb-4 under-review"
              v-if="
                profile.latest_paid_subscription && profile.active_subscription === null
              "
            >
              <i class="fa-solid fa-circle-exclamation"></i>

              <span>
                Seu plano
                <strong>{{ formatPlan(profile.latest_paid_subscription.plan) }}</strong>
                expirou em
                <strong>{{
                  formatTimestamp(profile.latest_paid_subscription.end_timestamp)
                }}</strong
                >.</span
              >
            </div>

            <div
              class="alert alert-info mb-4 under-review"
              v-if="profile.active_subscription !== null"
            >
              <i class="fa-regular fa-credit-card"></i>
              <span>
                Você está assinando o plano
                <strong>{{ formatPlan(profile.active_subscription.plan) }}</strong
                >. Seu plano expira em
                <strong>{{
                  formatTimestamp(profile.active_subscription.end_timestamp)
                }}</strong
                >.</span
              >
            </div>
          </div>

          <!-- Plan table -->
          <div class="row gy-4">
            <div class="col-md-6">
              <div class="tab">
                <h1>Free</h1>
                <a class="btn btn-small" style="visibility: hidden">.</a>
              </div>
              <div class="description-part section plan">
                <div style="padding-top: 0.2rem">
                  <strong class="price">Gratuito</strong>
                  <em class="current-plan" v-if="profile.plan === 'Free'">
                    (seu plano)</em
                  >
                  <em class="current-plan" v-else style="visibility: hidden">.</em>

                  <ul class="mt-4">
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Curso de
                      Introdução à AV
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Comunidade
                      Virtap
                    </li>
                    <li>
                      <i class="fas fa-times-circle" style="color: #f64b2f"></i>Formação
                      Completa em AV
                    </li>
                    <li>
                      <i class="fas fa-times-circle" style="color: #f64b2f"></i>Vídeo
                      aulas exclusivas
                    </li>
                    <li>
                      <i class="fas fa-times-circle" style="color: #f64b2f"></i>Propostas
                      ilimitadas
                    </li>
                    <li>
                      <i class="fas fa-times-circle" style="color: #f64b2f"></i>Prioridade
                      nas propostas
                    </li>
                    <li>
                      <i class="fas fa-times-circle" style="color: #f64b2f"></i>Mentorias
                      em grupo AO VIVO
                    </li>
                  </ul>

                  <a class="btn btn-secondary btn-small mt-2" style="visibility: hidden"
                    >.</a
                  >
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="tab" style="background: #e4daf3; border-bottom: 0">
                <h1>Virtap Club</h1>
                <a
                  class="btn btn-small disabled"
                  @click="subscribe('VirtapClub')"
                  v-if="profile.status === 1"
                  disabled
                  ><i class="fa fa-cart-shopping" style="padding-right: 5px"></i>
                  Assinar</a
                >
                <a
                  class="btn btn-small"
                  @click="subscribe('VirtapClub')"
                  v-else-if="
                    profile.plan === 'Free' &&
                    profile.latest_paid_subscription &&
                    profile.active_subscription === null &&
                    profile.latest_paid_subscription.plan === 'VirtapClub'
                  "
                  ><i class="fa fa-refresh" style="padding-right: 5px"></i> Renovar</a
                >
                <a
                  class="btn btn-small"
                  @click="subscribe('VirtapClub')"
                  v-else-if="profile.plan !== 'VirtapClub'"
                  ><i class="fa fa-cart-shopping" style="padding-right: 5px"></i>
                  Assinar</a
                >
              </div>

              <div class="description-part section plan" style="background: #e4daf3">
                <div style="padding-top: 0.2rem">
                  <strong class="price"
                    >12x de R$ 79,90/mês
                    <!-- <span style="color: #f64b2f"> (22% OFF)</span> -->
                    <!-- <s style="font-size: 80%; color: #f64b2f">
                      12x de R$ 89,90/mês
                    </s> -->
                  </strong>
                  <em class="current-plan" v-if="profile.plan === 'VirtapClub'">
                    (seu plano)</em
                  >
                  <em class="current-plan" v-else style="visibility: hidden">.</em>
                  <ul class="mt-4">
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Curso de
                      Introdução à AV
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Comunidade
                      Virtap
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Formação
                      Completa em AV
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Vídeo
                      aulas exclusivas
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Propostas
                      ilimitadas
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Prioridade
                      nas propostas
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Mentorias
                      em grupo AO VIVO
                    </li>

                    <a
                      class="btn btn-secondary btn-small mt-2"
                      :href="virtapClubPage"
                      target="_blank"
                      ><i class="fa fa-plus" /> Saiba mais</a
                    >
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- Billing details -->
          <div class="row gy-4 mt-2" v-if="profile.billing_details">
            <div class="col-12">
              <div class="tab">
                <h1>Dados para nota fiscal</h1>
                <div>
                  <a class="btn btn-small" @click="editBillingDetails()"
                    ><i class="fa fa-pencil" style="padding-right: 5px"></i> Editar</a
                  >
                </div>
              </div>
              <div class="section">
                <div>
                  <p><strong>Nome:</strong> {{ profile.billing_details.name }}</p>
                  <p>
                    <strong>CPF/CNPJ:</strong>
                    {{ formatCPFCNPJ(profile.billing_details.cpf_cnpj) }}
                  </p>
                  <p class="mt-3">
                    <strong>Endereço:</strong>
                    {{
                      formatAddress(
                        profile.billing_details.address,
                        profile.billing_details.address_number,
                        profile.billing_details.complement,
                        profile.billing_details.neighborhood
                      )
                    }}
                  </p>
                  <p>
                    <strong>CEP:</strong>
                    {{ formatZipCode(profile.billing_details.zipcode) }}
                  </p>
                  <p>
                    <strong>Cidade:</strong>
                    {{
                      formatCity(
                        profile.billing_details.state,
                        profile.billing_details.city
                      )
                    }}
                    -
                    {{ profile.billing_details.state }}
                  </p>
                  <p class="mt-3" v-if="profile.billing_details.phone">
                    <strong>Telefone:</strong
                    >{{ formatPhone(profile.billing_details.phone) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "../SideBar.vue";
import TopBar from "../TopBar.vue";
import AssistantManager from "../../../js/services/assistant.js";
import StringUtils from "../../../js/utils/string.js";
import FileUtils from "../../../js/utils/file.js";
import Config from "../../../../resources/config.js";

export default {
  components: { SideBar, TopBar },

  created() {
    this.$store.commit("setActiveSection", "PlanPage");
    this.$store.commit("setActiveProjectList", null);
    this.loadClientProfile();
  },

  data() {
    return {
      profile: null,
    };
  },

  computed: {
    loading() {
      return this.$store.state.loading;
    },
    utmParams() {
      return "utm_source=plataforma&utm_medium=assistentes&utm_campaign=assinatura-virtapclub&utm_content=planos";
    },
    next() {
      return `plano`;
    },
    virtapClubPage() {
      return Config.virtapClubPage + `?${this.utmParams}&next=${this.next}`;
    },
    subscribePage() {
      return (
        Config.subscribePage + `?plano=VIRTAPCLUB&${this.utmParams}&next=${this.next}`
      );
    },
  },

  methods: {
    async loadClientProfile() {
      this.$store.commit("setLoading", true);
      try {
        this.profile = await AssistantManager.getPlan();
        this.$store.commit("setActiveUser", this.profile);
        this.$store.commit("setLoading", false);
      } catch (error) {
        this.handleAPIError(error, "plano");
      }
    },
    formatPlan(plan) {
      if (plan === "VirtapClub") {
        return "Virtap Club";
      } else {
        return plan;
      }
    },

    editBillingDetails() {
      let $ctx = this;
      let $modal = $("#editBillingDetailsModal");

      let $cpf_cnpj = $modal.find("[data-cpf-cnpj]");
      let $name = $modal.find("[data-name]");
      let $address = $modal.find("[data-address]");
      let $number = $modal.find("[data-number]");
      let $complement = $modal.find("[data-complement]");
      let $neighborhood = $modal.find("[data-neighborhood]");
      let $cep = $modal.find("[data-cep]");
      let $city = $modal.find("[data-city]");
      let $uf = $modal.find("[data-uf]");
      let $phone = $modal.find("[data-phone]");

      $cpf_cnpj
        .data("get-field", function () {
          if (!$ctx.validateCPFCNPJ($cpf_cnpj.val().trim())) {
            $cpf_cnpj.closest(".item").addClass("error");
            return undefined;
          } else {
            $cpf_cnpj.closest(".item").removeClass("error");
            let val = $ctx.formatCPFCNPJ($cpf_cnpj.val().trim().replace(/\D/g, ""));
            $cpf_cnpj.val(val);
            return val.replace(/\D/g, "");
          }
        })
        .val($ctx.formatCPFCNPJ($ctx.profile.billing_details.cpf_cnpj));

      $name
        .data("get-field", function () {
          if (!$ctx.validateName($name.val().trim())) {
            $name.closest(".item").addClass("error");
            return undefined;
          } else {
            $name.closest(".item").removeClass("error");
            return $name.val().trim();
          }
        })
        .val($ctx.profile.billing_details.name);

      $address
        .data("get-field", function () {
          if (!$ctx.validateAddress($address.val().trim())) {
            $address.closest(".item").addClass("error");
            return undefined;
          } else {
            $address.closest(".item").removeClass("error");
            return $address.val().trim();
          }
        })
        .val($ctx.profile.billing_details.address);

      $number
        .data("get-field", function () {
          if (!$ctx.validateAddressNumber($number.val().trim())) {
            $number.closest(".item").addClass("error");
            return undefined;
          } else {
            $number.closest(".item").removeClass("error");
            return $number.val().trim();
          }
        })
        .val($ctx.profile.billing_details.address_number);

      $complement
        .data("get-field", function () {
          return $complement.val().trim();
        })
        .val($ctx.profile.billing_details.complement);

      $neighborhood
        .data("get-field", function () {
          if (!$ctx.validateNeighborhood($neighborhood.val().trim())) {
            $neighborhood.closest(".item").addClass("error");
            return undefined;
          } else {
            $neighborhood.closest(".item").removeClass("error");
            return $neighborhood.val().trim();
          }
        })
        .val($ctx.profile.billing_details.neighborhood);

      $cep
        .data("get-field", function () {
          if (!$ctx.validateCEP($cep.val().trim())) {
            $cep.closest(".item").addClass("error");
            return undefined;
          } else {
            $cep.closest(".item").removeClass("error");
            let val = $ctx.formatZipCode($cep.val().trim().replace(/\D/g, ""));
            $cep.val(val);
            return val.replace(/\D/g, "");
          }
        })
        .val($ctx.profile.billing_details.zipcode);

      $uf
        .data("get-field", function () {
          return $uf.val();
        })
        .val($ctx.profile.billing_details.state);

      $ctx.populateMunicipios($ctx.profile.billing_details.state, $city);
      $city
        .data("get-field", function () {
          return $city.val();
        })
        .val($ctx.profile.billing_details.city);

      if (!$phone.data("get-field")) {
        let intl = window.intlTelInput($phone[0], {
          autoInsertDialCode: true,
          initialCountry: "BR",
          separateDialCode: true,
        });

        $phone.data("intl", intl);

        $phone.data("get-field", function () {
          if (!intl.isValidNumber()) {
            $phone.closest(".item").addClass("error");
            return undefined;
          } else {
            $phone.closest(".item").removeClass("error");
            intl.setNumber($phone.val());
            return intl.getNumber();
          }
        });
      }
      $phone.data("intl").setNumber($ctx.profile.billing_details.phone);
      $uf.off().on("change", function () {
        const ufSelecionado = $(this).val(); // Pega a UF selecionada
        $ctx.populateMunicipios(ufSelecionado, $modal.find("[data-city]")); // Chama a função para popular os municípios
      });

      function validate(item) {
        let func = $(item).data("get-field");
        if (func) {
          func();
        } else {
          $(item).closest(".item").addClass("error");
        }
      }

      $modal.find(".item").removeClass("error");
      $modal.find("input").each((i, item) => {
        validate(item);
        $(item)
          .off()
          .on("blur", () => {
            validate(item);
          });
      });

      let action = async function () {
        let hasError = false;
        $modal.find(".item").removeClass("error");
        $modal.find("input").each((i, item) => {
          if ($(item).data("get-field")() === undefined) {
            hasError = true;
          }
        });

        if (hasError) {
          return;
        }

        let billingDetails = {
          name: $name.val().trim(),
          cpf_cnpj: $cpf_cnpj.val().trim().replace(/\D/g, ""),
          address: $address.val().trim(),
          address_number: $number.val().trim(),
          complement: $complement.val().trim(),
          neighborhood: $neighborhood.val().trim(),
          zipcode: $cep.val().trim().replace(/\D/g, ""),
          city: $city.val().trim(),
          state: $uf.val().trim(),
        };

        billingDetails.phone = $phone.data("intl").getNumber();

        let result = await AssistantManager.updateBillingDetails(billingDetails);

        if (result.billingDetails) {
          $ctx.profile.billing_details = result.billingDetails;
        } else {
          throw new Error("Falha ao atualizar dados para nota fiscal.");
        }

        return true;
      };

      this.showModal(
        $modal,
        function () {
          $modal.find("[data-cpf-cnpj]").focus();
        },
        "Salvar",
        action,
        "Dados atualizados.",
        "Ocorreu um erro editar os dados para nota fiscal.\nPor favor, tente novamente."
      );
    },
    subscribe(plan) {
      if (this.profile.status === 1) {
        this.showError(
          "Seu perfil ainda está sendo analisado.\n\nAssim que for aprovado, você poderá assinar o Virtap Club."
        );

        return false;
      }
      location.href = this.subscribePage;
    },

    manageStripeSubscription() {
      window.open(Config.apiHost + "/assistant/manage-subscription");
    },
  },
};
</script>
